import React from 'react';
import { HStack, NewContentButton } from '@design-system/pc';
import useSeqConsultControls from './hooks/useSeqConsultControls';
import TrackingService from '@/services/tracking';
import { SEQ_CONSULT_NEXT_BUTTON_ID } from '@/constants/seq-consult';

const SeqConsultControls = () => {
  const {
    isFirstStep,
    disabledNextStep,
    handleNext,
    handlePrev,
    isLastStep,
    prevButtonGtmKey,
    nextButtonGtmKey,
  } = useSeqConsultControls();
  return (
    <HStack
      width={570}
      marginLeft="auto"
      space="center"
      py="32px"
      position="sticky"
      bottom={0}
      backgroundColor="rgba(255, 255, 255, .9)"
    >
      {!isFirstStep && (
        <NewContentButton
          type="button"
          data-cypress-element="data-prev-button"
          width={120}
          emphasis="medium"
          size="lg"
          onClick={handlePrev}
          mr="8px"
          {...TrackingService.tagGTM(prevButtonGtmKey)}
        >
          이전
        </NewContentButton>
      )}

      <NewContentButton
        type="submit"
        data-cypress-element="seq-next-button"
        id={SEQ_CONSULT_NEXT_BUTTON_ID}
        width={280}
        emphasis="high"
        size="lg"
        disabled={disabledNextStep()}
        onClick={handleNext}
        {...TrackingService.tagGTM(nextButtonGtmKey)}
      >
        {isLastStep ? '상담신청' : '다음'}
      </NewContentButton>
    </HStack>
  );
};

export default SeqConsultControls;
